<div class="content-body default-height">
  <div class="container-fluid">
    <div class="card profile-overview profile-overview-wide" *ngIf="userInfo">
      <div class="card-body d-flex pb-1">
        <div class="clearfix">
          <div class="d-inline-block position-relative me-sm-4 me-3 mb-3 mb-lg-0">
            <label for="upload" class="c-pointer">
              <img [src]="userInfo?.profile_image" (error)="handleImageError($event)" alt="User Image" class="rounded-4 profile-avatar">
              <p class="glyphicon glyphicon-folder-open" aria-hidden="true">Update cover photo<i class="fa fa-edit ms-1"></i></p>
              <input type="file" id="upload" accept="image/*" class="display" (input)="updateCoverPhoto($event)">
            </label>
          </div>
        </div>
        <div class="clearfix d-xl-flex flex-grow-1">
          <div class="clearfix pe-md-5">
            <h3 class="fw-semibold mb-1">{{userInfo.first_name}} {{userInfo.last_name}}</h3>
            <ul class="d-flex flex-wrap fs-6 align-items-center">
              <li class="me-3 d-inline-flex align-items-center">
                <i class="las la-phone me-1 fs-18"></i>{{userInfo.phone}}
              </li>
              <li class="me-3 d-inline-flex align-items-center">
                <i class="las la-envelope me-1 fs-18"></i>{{userInfo.email}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="userInfo">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-header py-3">
            <h6 class="card-title">Personal Information</h6>
            <a class="btn btn-primary btn-sm" href="javascript:void(0);" (click)="togglePersonal()">Edit</a>
          </div>
          <div class="card-body">
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Gender</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.gender}}</span>
              </div>
            </div>

            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Current Phone</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.phone}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Alternate Number</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.alternate_phone}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Alternate Email</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.alternate_email}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Date Of Birth</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.dob}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Marital Status</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.marital_status}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Pan Number</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.pan}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Aadhaar Number</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.aadhar}}</span>
              </div>
            </div>

            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Driving Licence No</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{personal_info?.driving_license}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6">
        <div class="card">
          <div class="card-header py-3">
            <h6 class="card-title">Address information</h6>
            <a href="javascript:void(0);" class="btn btn-sm btn-primary" (click)="toggleAddress()">Edit</a>
          </div>
          <div class="card-body">
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Address</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.address}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">City</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.city}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">State</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.state}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Country</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.country}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Zipcode</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.address_info?.postal_code}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6">
        <div class="card">
          <div class="card-header py-3">
            <h6 class="card-title">Work information</h6>
            <a href="javascript:void(0);" class="btn btn-sm btn-primary" (click)="toggleWork()">Edit</a>
          </div>
          <div class="card-body">
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Company Name</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.company_name}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Address</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.company_address}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Phone</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.company_phone}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Email</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.company_email}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Designation</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.designation}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Department</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.department}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Work start date</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.work_start_date | date:'dd-MM-yyyy'}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Work end date</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.work_end_date | date:'dd-MM-yyyy'}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Monthly Income</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.monthly_income}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Work Experience</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.work_experience}}</span>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-6">
                <span class="fs-13">Work Location</span>
              </div>
              <div class="col-6">
                <span class="fs-13 text-secondary fw-semibold">{{userInfo.work_info?.work_location}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Personal Information Edit Modal -->
<div #add_personal_popup class="offcanvas offcanvas-end customeoff" tabindex="-1" id="add_personal" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">Personal Information</h5>
    <button type="button" class="btn-close" (click)="personalCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="personalForm" (ngSubmit)="onPersonalSubmit()" autocomplete="off">
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="gender" class="form-label">Gender</label>
            <select class="form-control" id="gender" formControlName="gender">
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="phone" class="form-label">Phone<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="phone" placeholder="1234567890" formControlName="phone">
            <div *ngIf="personalForm?.get('phone')?.invalid && personalForm?.get('phone')?.touched" class="required">
              Phone is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="alternate_phone" class="form-label">Alternate Phone</label>
            <input type="text" class="form-control" id="alternate_phone" placeholder="1234567890" formControlName="alternate_phone">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="alternate_email" class="form-label">Alternate Email</label>
            <input type="email" class="form-control" id="alternate_email" placeholder="alternate@email.com" formControlName="alternate_email">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="dob" class="form-label">Date of Birth</label>
            <input type="date" class="form-control" id="dob" formControlName="dob">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="marital_status" class="form-label">Marital Status</label>
            <select class="form-control" id="marital_status" formControlName="marital_status">
              <option value="">Select Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
            </select>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="pan" class="form-label">PAN Number</label>
            <input type="text" class="form-control" id="pan" placeholder="ABCDE1234F" formControlName="pan">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="aadhar" class="form-label">Aadhaar Number</label>
            <input type="text" class="form-control" id="aadhar" placeholder="1234 5678 9012" formControlName="aadhar">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="driving_license" class="form-label">Driving License</label>
            <input type="text" class="form-control" id="driving_license" placeholder="DL123456789" formControlName="driving_license">
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="personalForm.invalid || loadingService.isLoading()">Save</button>
          <button class="btn btn-danger light me-1" type="button" (click)="personalCancel()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Address Information Edit Modal -->
<div #add_address_popup class="offcanvas offcanvas-end customeoff" tabindex="-1" id="add_address" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">Address Information</h5>
    <button type="button" class="btn-close" (click)="addressCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="addressForm" (ngSubmit)="onAddressSubmit()" autocomplete="off">
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="address" class="form-label">Address<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="address" placeholder="HYD" formControlName="address">
            <div *ngIf="addressForm?.get('address')?.invalid && addressForm?.get('address')?.touched" class="required">
              Address is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="country" class="form-label">Country<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="countries" [templates]="template" class="select2" placeholder="Select country"
              formControlName="country" (update)="getStates()">
              <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('country')?.invalid && addressForm?.get('country')?.touched" class="required">
              Country is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="state" class="form-label">State<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="states" [templates]="template"
              class="select2" value="" placeholder="Select state" formControlName="state" (update)="getCities()">
              <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('state')?.invalid && addressForm?.get('state')?.touched" class="required">
              State is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="city" class="form-label">City<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="cities" [templates]="template"
              class="select2" value="" placeholder="Select city" formControlName="city">
              <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
            <div *ngIf="addressForm?.get('city')?.invalid && addressForm?.get('city')?.touched" class="required">
              City is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="postal_code" class="form-label">Zipcode<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="postal_code" placeholder="987456" formControlName="postal_code">
            <div *ngIf="addressForm?.get('postal_code')?.invalid && addressForm?.get('postal_code')?.touched" class="required">
              Zipcode is required
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="addressForm.invalid || loadingService.isLoading()">Save</button>
          <button class="btn btn-danger light me-1" type="button" (click)="addressCancel()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Work Information Edit Modal -->
<div #add_work_popup class="offcanvas offcanvas-end customeoff" tabindex="-1" id="add_work" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">Work Information</h5>
    <button type="button" class="btn-close" (click)="workCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="workForm" (ngSubmit)="onWorkSubmit()" autocomplete="off">
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="company_name" class="form-label">Company Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="company_name" placeholder="ABC" formControlName="company_name">
            <div *ngIf="workForm?.get('company_name')?.invalid && workForm?.get('company_name')?.touched" class="required">
              Company name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="company_address" class="form-label">Address<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="company_address" placeholder="HYD" formControlName="company_address">
            <div *ngIf="workForm?.get('company_address')?.invalid && workForm?.get('company_address')?.touched" class="required">
              Address is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="company_phone" class="form-label">Phone</label>
            <input type="text" class="form-control" id="company_phone" placeholder="1234567890" formControlName="company_phone">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="company_email" class="form-label">Email</label>
            <input type="text" class="form-control" id="company_email" placeholder="abc@mail.com" formControlName="company_email">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="designation" class="form-label">Designation</label>
            <input type="text" class="form-control" id="designation" placeholder="Engineer" formControlName="designation">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="department" class="form-label">Department</label>
            <input type="text" class="form-control" id="department" placeholder="department" formControlName="department">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="monthly_income" class="form-label">Monthly Income</label>
            <input type="text" class="form-control" id="monthly_income" placeholder="0" formControlName="monthly_income">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="work_start_date" class="form-label">Work Start Date</label>
            <input type="date" class="form-control" id="work_start_date" formControlName="work_start_date">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="work_end_date" class="form-label">Work End Date</label>
            <input type="date" class="form-control" id="work_end_date" formControlName="work_end_date" [min]="workForm.get('work_start_date')?.value">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="work_experience" class="form-label">Work Experience</label>
            <input type="text" class="form-control" id="work_experience" placeholder="0" formControlName="work_experience">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="work_location" class="form-label">Work Location</label>
            <input type="text" class="form-control" id="work_location" placeholder="0" formControlName="work_location">
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="workForm.invalid || loadingService.isLoading()">Save</button>
          <button class="btn btn-danger light me-1" type="button" (click)="workCancel()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
